import { render, staticRenderFns } from "./OutroButtonContainer.vue?vue&type=template&id=2472481c&scoped=true"
import script from "./OutroButtonContainer.vue?vue&type=script&lang=js"
export * from "./OutroButtonContainer.vue?vue&type=script&lang=js"
import style0 from "./OutroButtonContainer.vue?vue&type=style&index=0&id=2472481c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472481c",
  null
  
)

export default component.exports